<template>
  <div class="award-wrapper" :class="{'mt-5': margin}">
    <div class="container">
      <div class="awards-img flex-direction-lg-row">
        <img :src="require(`@/assets/live-hr-advice/calls-taken-${$i18n.locale}.png`)">
        <div class="awards-img mt-2 mt-md-0">
          <img src="@/assets/complete/chrr-5-star-hr-consultant-2021.png">
          <img src="@/assets/complete/professional-services.png">
          <img src="@/assets/complete/gptw-certified-sep-2018-2019.png">
          <img src="@/assets/complete/2019-ctgc-cmyk.png">
          <img src="@/assets/complete/growth-500.png">
          <img src="@/assets/complete/profit-500.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Awards',
  props: {
    margin: {
      required: false,
      default: true
    }
  }
}
</script>

<style lang="sass" scoped>
.award-wrapper
  padding: 30px 0
  color: $white
  position: relative
  width: 100vw
  height: 100%
  left: 50%
  transform: translateX(-50vw)
  z-index: 0
  background-color: $purple

.awards-img
  flex-grow: 1
  justify-content: space-around
  display: flex
  flex-wrap: wrap
  margin: 0 -10px

  img
    margin: 10px
    max-height: 90px
</style>



// WEBPACK FOOTER //
// src/components/ui/products/AwardsCalls.vue